import { B, fonts } from "./UI";

function sanitizePhone(phone = "") {
  return phone.replace(/\D/g, "");
}

export default function StickyCallButton({ phone }) {
  const phoneNumber = sanitizePhone(phone);
  if (!phoneNumber) return null;

  return (
    <a
      href={`tel:${phoneNumber}`}
      aria-label={`Call ${phoneNumber}`}
      style={{
        position: "fixed",
        right: 18,
        bottom: "calc(18px + env(safe-area-inset-bottom, 0px))",
        zIndex: 1400,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "11px 16px",
        borderRadius: 999,
        border: `1px solid ${B.orangeDark}`,
        background: B.orange,
        color: "#fff",
        textDecoration: "none",
        fontFamily: fonts.body,
        fontSize: 13,
        fontWeight: 700,
        boxShadow: "0 10px 28px rgba(0,0,0,0.22)",
      }}
    >
      <span aria-hidden>📞</span>
      Call Now
    </a>
  );
}
